import TagIcon from "assets/icons/tagIcon";
import styles from "./style.module.scss";

interface ClassTagProps {
  value: string;
}

export default function ClassTag({ value }: ClassTagProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.tagIcon} data-testid="class-tag-icon">
        <TagIcon />
      </div>
      <span className={styles.tagText} title={value}>
        {value}
      </span>
    </div>
  );
}
